import { makeAutoObservable, runInAction } from "mobx";
import store from "./store";
import { applicantTrackingAPI } from "../services/applicantTracking/applicantTrackingAPI";

export default class OfferLetterStore {
  constructor() {
    makeAutoObservable(this);
  }

  loading = false;
  error = false;

  handleFinalSubmit = async (values, apiFunction, applicantId, userId, currentStatus) => {
    runInAction(() => {
      this.loading = true;
      this.error = false;
    });

    try {
      const payload = {
        applicantId: applicantId,
        senderId: userId,
        subject: values.subject,
        content: values.content,
      };

      await apiFunction.create(payload);

      if (currentStatus !== "Declined") {
        await this.handleUpdateApplicationStatus(applicantId, "Offered");
      }

      store.notificationStore.showNotification("Your message has been delivered", "success", {
        title: `Message sent!`,
        duration: 5000,
      });

      return true;
    } catch (error) {
      runInAction(() => {
        this.error = true;
      });
      const errorMessage = error.response?.data?.message || "Failed to send message";
      store.notificationStore.showNotification(errorMessage, "error", { title: "Error" });
      return false;
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  };

  handleUpdateApplicationStatus = async (id, status) => {
    runInAction(() => {
      this.loading = true;
    });

    try {
      const success = await applicantTrackingAPI.updateApplicationStatus(id, status);
      return success;
    } finally {
      runInAction(() => {
        this.loading = false;
      });
    }
  };
}
